import { Instagram } from 'lucide-react';

export function InstagramSectionClassic() {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-8">
        {/* Header */}
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 rounded-xl flex items-center justify-center">
              <Instagram className="w-7 h-7 text-white" />
            </div>
            <h2 className="text-2xl md:text-3xl font-black uppercase text-foreground">
              Follow us on Instagram
            </h2>
          </div>
          
          {/* Profile Info */}
          <div className="flex items-center justify-center gap-6 flex-wrap">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">MFS</span>
              </div>
              <span className="font-bold text-lg">@modularfurniturestore</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
